import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/components/common/selectitem';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-filter-view',
  templateUrl: './filter-view.component.html',
  providers: [DatePipe]
})
export class FilterViewComponent implements OnInit {

  @Output() queryStringEmitter = new EventEmitter();
  @Output() selectedFilterEmitter = new EventEmitter();
  @Output() searchedFilterBarcodeEmitter = new EventEmitter();
  errorHandler: ErrorHandler = new ErrorHandler;
  orderStatusList: SelectItem[];
  selectedOrderStatus: string;
  dateOptions: any[] = [];
  filterDate: any;
  startDate: Date = new Date();
  endDate: Date;
  subStringOptions: any[];
  selectedSubstringSearch: string;
  selectedBarcodeSearch: string;
  selectedSupportCategory: string;
  salesItemTypes: any[] = [];
  selectedSIT: string;
  subStringSearch: string;
  supportCategories: any[] = [];
  barcodeTypeOptions: any[] = [];
  inputBarcode: string;
  showAllLabs:boolean;
  disableCheckbox : boolean;
  constructor(private masterDataService: MasterDataService, private messagesService: MessagesService, private datePipe: DatePipe) { }

  ngOnInit() {

    this.orderStatusList = [
      { label: 'All', value: 'ALL' },
      { label: 'New', value: 'New' },
      { label: 'Complete', value: 'COMPLETE' },
      { label: 'Received', value: 'IN_PROCESS' },
      { label: 'Cancel', value: 'CANCEL' },
      { label: 'Partial Results', value: 'PARTIAL_RESULTS' }];
    this.selectedOrderStatus = 'New';
    this.disableCheckbox = true;
    this.showAllLabs = true;
    this.supportCategories.push({ value: 'OK', label: 'fa fa-check-circle-o' });
    this.supportCategories.push({ value: 'LEAKAGE', label: 'fa fa-tint' });
    this.supportCategories.push({ value: 'BARCODE', label: 'fa fa-barcode' });
    this.supportCategories.push({ value: 'UNHAPPY', label: 'fa fa-frown-o' });
    this.supportCategories.push({ value: 'MATERIAL_MISSING', label: 'fa fa-hand-lizard-o' });
    this.supportCategories.push({ value: 'GatcLims', label: 'fa fa-search' });

    this.dateOptions.push({ label: 'Order Date', value: 'creationDate' });
    this.dateOptions.push({ label: 'Received Date', value: 'receivedDate' });
    this.dateOptions.push({ label: 'Complete Date', value: 'completeDate' });

    this.filterDate = 'creationDate';
    this.startDate.setDate(this.startDate.getDate() - 14);
    this.subStringOptions = [
      { label: 'Customer Name', value: 'Customer Name' },
      { label: 'Sample Name', value: 'Sample Name' },
      { label: 'Primer Name', value: 'Primer Name' },
      { label: 'Plate Name', value: 'Plate Name' },
      { label: 'Email', value: 'Email' },
      { label: 'Address', value: 'Address' }
    ];

    this.barcodeTypeOptions = [
      { label: 'Material Barcode', value: 'Material Barcode' },
      { label: 'Plate Barcode', value: 'Plate Barcode' },
    ]
    this.filterOrders();
    this.getSalesItemTypesFromMDM();
  }

  getSalesItemTypesFromMDM() {
    let lab = JSON.parse(localStorage.getItem("lab"));
    this.masterDataService.getSalesItemTypeFilteredByLab(lab.lab._id).subscribe(
      results => {
        if (!results) {
          return;
        }
        results.data.forEach(element => {
          this.salesItemTypes.push({ label: element.sitKey, value: element.sitKey });
        });
        this.salesItemTypes.push({ label: 'Synthesized Primer', value: 'PrimerSynthBB' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    );
  }

  filterOrders() {
    let lab = JSON.parse(localStorage.getItem('lab'));
    if (this.selectedOrderStatus == null && this.filterDate == null && this.selectedSubstringSearch == null
      && this.selectedSupportCategory == null && this.selectedSIT == null) {
      this.messagesService.addErrorMessage({ severity: 'warn', summary: 'No Filter Selected', detail: 'Please select at least one filter criteria' });
      return;
    }
    let queryString = "orderStatus=";

    if (this.selectedOrderStatus == 'ALL')
      queryString += 'in=(New,COMPLETE,IN_PROCESS,CANCEL,PARTIAL_RESULTS)'
    else
      queryString += '=' + this.selectedOrderStatus;

    if (this.filterDate != null) {
      if (this.startDate != null) {
        let formattedStartDate = this.datePipe.transform(this.startDate, 'MM/dd/yyyy');
        queryString += ";" + this.filterDate + "=ge=" + formattedStartDate;
      }
    }

    if (this.endDate != null) {
      let formattedEndDate = this.datePipe.transform(this.endDate, 'MM/dd/yyyy');
      queryString += ";" + this.filterDate + "=le=" + formattedEndDate;
    }

    if (this.selectedSupportCategory != null)
      queryString += ";supportCategory==" + this.selectedSupportCategory;

    if (this.selectedSIT != null)
      queryString += ";salesItemType==" + this.selectedSIT;

    if (!this.showAllLabs && this.selectedOrderStatus != 'New')
      queryString += ";labId==" + lab.lab._id;
    if (this.selectedSubstringSearch != null) {
      let searchedString = this.subStringSearch.trim();
      if (this.selectedSubstringSearch == "Customer Name") {
        let strArr = searchedString.split(" ");
        let firstName = strArr[0];
        let lastName = strArr.length > 1 ? strArr[1] : strArr[0];
        queryString += ";(firstName=re="
          + firstName + ",lastName=re=" + lastName + ")";
      }
      else if (this.selectedSubstringSearch == "Sample Name") {
        queryString += ";sampleName=re=".concat("\"").concat(searchedString).concat("\"");
      } else if (this.selectedSubstringSearch == "Primer Name") {
        queryString += ";primerName=re=".concat("\"").concat(searchedString).concat("\"");
      } else if (this.selectedSubstringSearch == "Plate Name") {
        queryString += ";plateName=re=".concat("\"").concat(searchedString).concat("\"");
      }
      else if (this.selectedSubstringSearch == "Email")
        queryString += ";email=re=" + this.subStringSearch;
      else if (this.selectedSubstringSearch == "Address")
        queryString += ";(state=re="
          + this.subStringSearch + ",city=re="
          + this.subStringSearch + ",street=re="
          + this.subStringSearch + ",country=re="
          + this.subStringSearch + ",line1=re="
          + this.subStringSearch + ",line2=re=" + this.subStringSearch + ")";
    }
    if (this.selectedBarcodeSearch != "Plate Barcode" && this.selectedBarcodeSearch != "Material Barcode") {
      this.selectedBarcodeSearch = "";
      this.inputBarcode = "";
    }
    this.selectedFilterEmitter.emit(this.selectedBarcodeSearch);
    this.searchedFilterBarcodeEmitter.emit(this.inputBarcode);
    this.queryStringEmitter.emit(queryString);

  }

  clearFilters() {
    this.selectedOrderStatus = "ALL";
    this.filterDate = null;
    this.startDate = null;
    this.endDate = null;
    this.selectedSubstringSearch = null;
    this.subStringSearch = null;
    this.selectedSupportCategory = null;
    this.selectedSIT = null;
    this.selectedBarcodeSearch = null;
    this.inputBarcode = null;
    this.showAllLabs =false;
    this.filterOrders();
  }

  onDropDownChange() {
    if (this.filterDate == null) {
      this.startDate = null;
      this.endDate = null;
    }
  }
  onStatusDropDownChange() {
    if(this.selectedOrderStatus=='New') {
      this.showAllLabs = true;
      this.disableCheckbox = true;
    }
    else {
      this.showAllLabs = false;
      this.disableCheckbox = false;
    }
  }
}
